import { LogService } from '../../../../shared/services/log.service';
import { Validator } from '../../../../shared/services/validator';
import { CTRL_NAME_EXTRACTOR } from '../../ctrl.name.extractor';

export class CTRL_411_horsDef implements Validator {

    public static id = 'CTRL_411_horsDef';
    private message = 'error.ctr_411_HorsDef';


    public LOG: LogService = new LogService(CTRL_411_horsDef);

    
    validate(form: any, map) {

        
        // vérifier si la règle est applicable sur mon formulaire
        const rgs: string[] = CTRL_NAME_EXTRACTOR.getCtrlNames(form, CTRL_411_horsDef.id + '_');

        if (rgs.length > 0) {
            for (const rg of rgs) {
                const ctrl = form.controls[rg];
                const languesNameWithStepId = map.get(ctrl.value.rgCtrls.langues);
                const languesCtrl = form.controls[languesNameWithStepId];

                if (languesCtrl.value.length > 0) {
                    form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: false };
                } else {
                    // placer le message d'erreur
                    form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: true, validation_message: this.message };
                }
            }
        }
    }
}
